@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="dashboard-content-page" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <header>
        <div class="title">
            <lucide-angular name="home" size="44"></lucide-angular>
            <h1>{{ 'nav.dashboard.title' | translate }}</h1>
        </div>
    </header>
    <div id="content">

        @let clienPlan = clientPlan$ | async;
        @if(clienPlan){
        <div class="dashboard-element" id="my-plan">
            <p>{{ 'dashboard.my_plan.actual_plan' | translate }}</p>
            <p class="plan-name">{{ clienPlan.name }}</p>
            <p>{{ 'common.since' |translate}} {{ clienPlan.createdAt | date}}</p>
            <app-button routerLink="/dashboard/plans" type="discreet">{{ 'dashboard.my_plan.change_plan' | translate
                }}</app-button>
        </div>
        }

        @let jobCompletedCount = (jobCompletedCount$ | async) || 0;
        @let jobRunningCount = (jobRunningCount$ | async) || 0;
        @let jobWaitingResponseCount = (jobWaitingResponseCount$ | async) || 0;
        @if(jobCompletedCount > 0){
        <div id="jobs-completed" class="dashboard-element" (click)="router.navigate(['/dashboard/my-jobs'])">
            <span class="job-count">{{ jobCompletedCount }}</span>
            <p class="job-completed">jobs completed</p>
            <div class="divider"></div>
            <div class="secondary-job-count">
                <p class="secondary-count">{{ jobWaitingResponseCount }}</p>
                <p>{{ 'status.WAITING_RESPONSE' | translate}}</p>
            </div>
            <div class="secondary-job-count">
                <p class="secondary-count">{{ jobRunningCount }}</p>
                <p>{{ 'status.IN_PROGRESS' | translate}}</p>
            </div>
        </div>
        }

        @let lastJob = (lastJob$ | async);
        @if(lastJob){
        <app-job-row [job]="lastJob" (onClick)="router.navigate(['/dashboard/job', lastJob.id])"></app-job-row>
        }
    </div>
</div>